import { __spreadArray } from "tslib";
import { useSinglePrismicDocument } from '@prismicio/react';
export function usePrismicData() {
    var document = useSinglePrismicDocument('header')[0];
    if (!document) {
        return {};
    }
    var products = document.data.products.map(function (product) { return ({
        name: product.productname,
        url: product.producturl.url,
    }); });
    var slices = __spreadArray([], document.data.slices, true);
    slices.shift();
    var socials = slices.pop().items.map(function (item) { return ({
        img: item.navitemimg,
        url: item.navitemlink.url,
        target: item.navitemlink.target,
    }); });
    var submenus = slices.map(function (slice) {
        var content = slice.items.map(function (item) { return ({
            name: item.navitemlabel,
            url: item.navitemlink.url,
            target: item.navitemlink.target,
        }); });
        return {
            name: slice.primary.navlabel,
            content: content,
        };
    });
    var amburl = document.data.amburl.url;
    return {
        products: products,
        socials: socials,
        submenus: submenus,
        amburl: amburl,
    };
}
//# sourceMappingURL=usePrismicData.js.map